import { useNavigate } from 'react-router-dom';
import JourneyCards from '../../../../../components/JourneyCards';
import { CLIENT_JOURNEY, HOW_WE_WORK } from '../../constants';
import { SectionWrapper, SectionTitle, BottomText, ButtonContainer } from './styles';
import CTAButton from '../../../../../ui/ctaButton';

const HowWeWorkSection = () => {
  const navigate = useNavigate();

  const handleLearnMore = () => {
    navigate('/services');
  };

  return (
    <SectionWrapper>
      <SectionTitle align="center">{HOW_WE_WORK.title}</SectionTitle>
      <JourneyCards steps={CLIENT_JOURNEY} />
      <BottomText align="center">{HOW_WE_WORK.bottomText}</BottomText>
      <ButtonContainer>
        <CTAButton
          variant="contained"
          text={HOW_WE_WORK.buttonText}
          onClick={handleLearnMore}
        />
      </ButtonContainer>
    </SectionWrapper>
  );
};

export default HowWeWorkSection;
